export function arraysEqual(a: any[] | null, b: any[] | null, indexer: (item: any) => any = (item: any) => item) {
    if (a === b) {
        return true;
    }
    if (a == null || b == null) {
        return false;
    }
    if (a.length !== b.length) {
        return false;
    }

    if (a.length > 0 && b.length > 0) {
        const firstIsObjectArray = typeof a[0] === 'object';
        const secondIsObjectArray = typeof b[0] === 'object';
        const comparison = (n1: any, n2: any) => {
            const comp1 = n1?.id || n1;
            const comp2 = n2?.id || n2;

            if (comp1 && comp2) {
                if (comp1 > comp2) {
                    return 1;
                }

                if (comp1 < comp2) {
                    return -1;
                }
            }
            return 0;
        };

        const first = (firstIsObjectArray ? a.map(indexer) : [...a]).sort(comparison);
        const second = (secondIsObjectArray ? b.map(indexer) : [...b]).sort(comparison);
        const isObjectComparison = firstIsObjectArray && secondIsObjectArray;

        for (let i = 0; i < first.length; ++i) {
            if (isObjectComparison ? !deepEqual(first[i], second[i]) : first[i] !== second[i]) {
                return false;
            }
        }
    }
    return true;
}

const deepEqual = (object1: any, object2: any) => {
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);

    if (keys1.length !== keys2.length) {
        return false;
    }

    for (const key of keys1) {
        const val1 = object1[key];
        const val2 = object2[key];

        if (isSymbol(val1) || isSymbol(val2)) {
            continue;
        }

        const areObjects = isObject(val1) && isObject(val2);
        if ((areObjects && !deepEqual(val1, val2)) || (!areObjects && val1 !== val2)) {
            return false;
        }
    }

    return true;
};

const isObject = (obj: any) => {
    return obj != null && typeof obj === 'object';
};

// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
const TYPE_SYMBOL = (typeof Symbol === 'function' && Symbol.for && Symbol.for('react.element')) || 0xeac7;

const isSymbol = function (object: { $$typeof: number | symbol } | null) {
    return typeof object === 'object' && object !== null && object.$$typeof === TYPE_SYMBOL;
};
